import { baseBrandConfig } from '../brand';
/**
 * Legal Document Server — the brand the product shipped under before Movant.
 * The values are the ones the portal rendered (its own settings file, which
 * differed from this package's on the four sidebar colors and won).
 */
export const ldsBrand = {
    ...baseBrandConfig,
    company: {
        name: 'Legal Document Server',
        shortName: 'LDS',
        tagline: 'Your One Stop Shop For Litigation Support Solutions!',
        description: 'Full-service litigation support including eFiling, process serving, and court services.',
    },
    contact: {
        phone: {
            primary: '(800) 687-5003',
            secondary: '(310) 574-2282',
            fax: '(310) 598-1758',
        },
        hours: 'Monday-Friday 8 AM to 6 PM PT',
        addresses: {
            losAngeles: {
                label: 'Los Angeles',
                street: '7162 Beverly Boulevard, 508',
                city: 'Los Angeles',
                state: 'CA',
                zip: '90036',
            },
            orangeCounty: {
                label: 'Orange County',
                street: '30100 Town Center Drive, Suite C#1013',
                city: 'Laguna Niguel',
                state: 'CA',
                zip: '92677',
            },
        },
    },
    app: {
        version: '7.0.6716',
        copyright: 'Legal Document Server, Inc.',
        year: '2025',
    },
    colors: {
        primary: '#4D7CFE',
        primaryHover: '#3D6AE8',
        primaryLight: '#EBF0FF',
        secondary: '#1B365D',
        secondaryLight: '#2D4A7C',
        text: '#374151',
        textLight: '#6B7280',
        textMuted: '#9CA3AF',
        bgWhite: '#FFFFFF',
        bgLight: '#F8FAFC',
        bgCard: '#FFFFFF',
        bgAccent: '#EBF0FF',
        bgDark: '#1B365D',
        border: '#E5E7EB',
        borderDark: '#D1D5DB',
        success: '#10B981',
        warning: '#F59E0B',
        error: '#EF4444',
        info: '#3B82F6',
        sidebarBg: '#1B2850',
        sidebarText: '#A5B4C8',
        sidebarActive: '#4D7CFE',
        sidebarHover: '#2D3A5C',
        primaryAction: '#10B981',
        onPrimary: '#FFFFFF',
        link: '#4D7CFE',
    },
    typography: {
        fontFamily: {
            heading: "'Playfair Display', Georgia, serif",
            body: "'Inter', -apple-system, sans-serif",
            mono: "'JetBrains Mono', ui-monospace, monospace",
        },
    },
    logos: {
        // Blue artwork made for a light ground: the sidebar sets it on a white chip.
        primary: '/brand/lds/lds-logo-lockup.png',
        icon: null,
        dark: null,
        iconDark: null,
    },
    document: {
        title: 'Legal Document Server',
        description: 'Legal Document Server - Full-service litigation support including eFiling, process serving, and court services.',
        themeColor: '#4D7CFE',
        favicon: '/brand/lds/favicon.ico',
        appleTouchIcon: '/brand/lds/favicon.ico',
        manifest: '/brand/lds/manifest.json',
        fontsHref: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:wght@500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap',
    },
};
